export default __webpack_public_path__ + "static/media/message.eb43e583.svg";